export const marketsKey = ['markets']
